import bem from '../../../utils/bem';
import useWindowWidth from '../../../hooks/useWindowWidth';

const CTABanner = ({
  headline,
  media,
  description,
  cta,
  extra,
  bordered = true,
}) => {
  const { breakpoint } = useWindowWidth();
  const ctaBannerBaseClass = 'cta-banner';
  const mods = [];
  if (bordered) {
    mods.push('without-media', 'bordered', 'white');
  }
  return (
    <div
      className={bem('wrap', [], ctaBannerBaseClass, [])}
      data-component-name="[B12] CTA Banner"
    >
      <div className={bem(ctaBannerBaseClass, mods, '', extra)}>
        {media && (
          <div
            className={bem('background-image', mods, ctaBannerBaseClass, [])}
          >
            {media}
          </div>
        )}
        <div className={bem('card', [], 'cta-banner', ['flex', 'relative'])}>
          <div className={bem('content', [], 'card', [])}>
            {headline &&
              (breakpoint.isDesktop ? (
                <h4
                  className={bem('title', [], ctaBannerBaseClass, [
                    'component-headline',
                  ])}
                >
                  {headline}
                </h4>
              ) : (
                <h3
                  className={bem('title', [], ctaBannerBaseClass, [
                    'component-headline',
                  ])}
                >
                  {headline}
                </h3>
              ))}
            {description && (
              <div className={bem('description', [], 'card', [])}>
                {description}
              </div>
            )}
            {cta && (
              <a className={bem('btn', [], '', [])} href={cta.link_url}>
                {cta.link_content}
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTABanner;
